import { Component, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'app-st-button-delete-all',
  templateUrl: './st-button-delete-all.component.html',
  styleUrls: ['./st-button-delete-all.component.scss'],
  standalone: false
})
export class StButtonDeleteAllComponent {

  @Input()
  idVal: string = 'buttonId';

  @Input()
  label = 'Delete All';

  @Output()
  onClick = new EventEmitter<Event>();
}
